import React from 'react';
import { number, func, array, bool } from 'prop-types';

import './index.css';


const SelectorButtons = (props) => {

    const handleClick = (item) => {
        if (props.disabled) return;
        if (props.onChange) {
            props.onChange(item.id, item);
        }
    }

    return (
        <div className="selector-buttons">
            {props.items.map(item => (
                <button
                    key={item.id}
                    type="button"
                    className={`selector-btn${item.id === props.value ? ' selector-btn--selected' : ''}`}
                    onClick={() => handleClick(item)}
                    disabled={props.disabled}
                >
                    {props.labelFormat(item)}
                </button>
            ))}
            {props.items.length === 0 && (
                <span className="selector-buttons-empty">No hay opciones disponibles</span>
            )}
        </div>
    );
}

SelectorButtons.propTypes = {
    items: array.isRequired,
    value: number,
    onChange: func,
    disabled: bool,
    labelFormat: func,
};

SelectorButtons.defaultProps = {
    value: 0,
    onChange: null,
    disabled: false,
    labelFormat: (item) => item.codigo ? `${item.codigo} · ${item.nombre}` : item.nombre,
};

export default SelectorButtons;
